import { authAxios } from 'apis';
import Cookies from 'js-cookie';
const ENDPOINT = 'Authentication';

export const AuthService = {
	login: async (email: string, password: string) => {
		try {
			const formData = new FormData();
			formData.append('email', email);
			formData.append('password', password);

			const response = await authAxios.post(`${ENDPOINT}/Login`, formData);

			if (response.status === 200) {
				const token = response.data.token;
				Cookies.set('authToken', token, { expires: 7 });
			}
		}
		catch (e) {
			console.log(e);
			throw new Error('Unknown error. Please try again.');
		}
	},
	logout: () => {
		Cookies.remove('authToken');
	},
	confirmEmail: async (email: string, token: string) => {
		const formData = new FormData();
		formData.append('email', email);
		formData.append('token', token);
		const response = await authAxios.post(`${ENDPOINT}/ConfirmEmail`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data;
	},
};